import { selectFromOrganizationBillingDetailDto } from '../../models';

export default selectFromOrganizationBillingDetailDto()
  .id
  .name
  .status
  .currentPeriodEnd
  .currentPeriodStart
  .currentPeriodUsage
  .usageLimit
  .cancellationRequested
  .cancelAt
  .canceledAt
  .currentCycleSmsMessageCount
  .currentCycleSmsSegmentCount
  .smsAddonActive
  .toString();
